/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import map from 'lodash/map';
import _ from 'lodash';
import { Flexbox, GridGroup, GroupButton, ActivityFlex, FitnessCommonContainer, FitnessChampionsCard, TitleContainer, Title, FitnessNewUserCard, FitnessEmployeeGrid, FitnessTabContainer, CardContainer, GroupActivityValue, /*ProfileLogoContainer,*/MinutesActiveDescription, FitnessUserCardContainer, 
  CurrentYear,BarLine ,NewCardContainer,Row1,ImgContainer, BoxData, NewTotalData, NewImgContainer, CustomDropDown,ContentWrap, MostActiveUserCard, FitnessActivityWrap, FitnessActivityCard, CompanyActvity , CompanyActvityCard } from './styles';
import {NoData } from '../EngagementSection/styles';
import { HeaderContainer, HeaderTitle, HeaderImage } from '../HealthTab/styles';
import UserCard from '../UserCardV3';
import VerticalBarChart from '../VerticalBarChart';
import HighChatV2 from '../HighChatV2';
import PieChart from '../PieChart';
import { getUnit, getActivityDate, cleanUpCommas } from '../../utils/methods';
import {FilterAdminDropIcon} from '../../utils/icons'
import { FetchGroupActivitySummary } from '../../redux/actions';
import Waiting from '../Waiting';
import { ImageUrl } from '../../utils/constants';
import { DropdownItem } from 'react-bootstrap';
import LazyImage from '../common/LazyImage/LazyImage';
const monthData = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const weekData = ["Q1", "Q2", "Q3", "Q4"];
import {FitnessDeviceCard} from '../CompanyChallengesAdminUpdated/style'
import { ProgressBar } from '../HealthTabV2/HealthTabUpdated/styles';
import { CustomDropdownItem, CustomMenu, CustomToggle, CustomToggleWrapper, DropdownWrapper } from "../common/CommonYearFilter/style";
import Dropdown from "react-bootstrap/Dropdown";
import BarChart from '../common/Manager/BarChart';

class FitnessTab extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      activeButton: 'Yearly',
      activeYear:new Date().getFullYear(),
      groupActivitySummaryData: monthData, 
      weekButton: false,
      monthButton: false,
      yearButton: true,
      activeIndex: 0,
      companyId: '',
      getDate: monthData[0],
      getYear: 0,
      displayLogo: false,
      selectedIndex: 0,
      selectedIndex1: null,
      selectedValue: null,
      options: ["2019","2018","2017"],
      showMore: false,
      yearData: props.yearList,
      currentYear: new Date().getFullYear(),
      value: "Monthly",
      year:'year'
    }
  }

  componentDidMount() {
    this.fetchAPIForActivity();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if(prevState.getDate !== this.state.getDate) {
  //     this.fetchAPIForActivity();
  //   }
  // }

  UNSAFE_componentWillReceiveProps() {
    const { companyId } = this.props;
    if(companyId != this.state.companyId) {
      this.fetchAPIForActivity();
      this.setState({yearData:this.props.yearList, getYear: this.props.yearList.length - 1}, ()=>{
        this.getGroupSummary(weekData, monthData, this.state.yearData)
      })
    }
  }

  fetchAPIForActivity = () => {
    const { fetchGroupActivitySummary, companyId } = this.props;
    const {yearData} = this.state;
    let obj = {};
    if(this.state.yearButton) {
      obj = getActivityDate('year',yearData[this.state.getYear]);
    }
    else {
      obj = getActivityDate(this.state.getDate,yearData[this.state.getYear]);
    }
    fetchGroupActivitySummary(companyId, obj.startDate, obj.endDate)
    this.setState({companyId})
  };

  getGroupSummary = (WeekData, monthData,yearData) => {
    const { activeButton } = this.state;
    switch(activeButton) {
    case 'Quarterly':
      this.setState({
        groupActivitySummaryData: WeekData,
        weekButton: true,
        monthButton: false,
        yearButton: false,
        getDate: weekData[0],
        activeIndex: 0
      }, () => {
        this.fetchAPIForActivity();
      });
      break;
    case 'Monthly':
      this.setState({
        groupActivitySummaryData: monthData,
        weekButton: false,
        monthButton: true,
        yearButton: false,
        activeIndex: 0,
        getDate: monthData[0]
      }, () => {
        this.fetchAPIForActivity();
      })

      break;
    case 'Yearly':
      this.setState({
        groupActivitySummaryData: yearData,
        weekButton: false,
        monthButton: false,
        yearButton: true,
        getDate: yearData[this.state.getYear],
        activeIndex: 0
      }, () => {
        this.fetchAPIForActivity();
      });
      break;
 
    }
  };

  changeActiveButton = (value, weekData, monthData, yearData) => {
    this.setState({
      activeButton: value
    }, () => {
      this.getGroupSummary(weekData, monthData, yearData)
    })
  };

  changeActiveYear = (value, yearData,index) => {
    this.setState({
      activeYear: value,
      activeButton: "Yearly",
      getYear:index,
      weekButton: false,
      monthButton: false,
      yearButton: true,
    
      getDate: yearData[this.state.getYear]

    }, () => {
      this.fetchAPIForActivity();
    })
  };
  
  getModelLogo = (url) => (
    <HeaderImage src={`/images/CompanyDashBoardV2/${url}`} />
  );

  selectTitle = (e)  => {
    this.setState({value : e.target.value}); 
  }
  showUsersCard = (userData) => {
    const {showMore} = this.state;
    const slicedUserData = userData?.slice(0, 6);
    if (showMore === true) {
      return userData.map((data, index) => (
        <FitnessChampionsCard key={index} isBigImage  newWidth={"newWidth"} newPadding={"newPadding"}>
          <div>
            <UserCard data={data}/>
          </div>
        </FitnessChampionsCard>
      ))
    }

    else {
      return slicedUserData?.map((data, index) => (
        <FitnessChampionsCard key={index} isBigImage newWidth={"newWidth"} newPadding={"newPadding"}>
          <div>
            <UserCard data={data}/>
          </div>
        </FitnessChampionsCard>
      ))
    }

  };

  showMoreCards = () => {
    this.setState ((prev) => ({showMore: !prev.showMore}))
  };

  renderHeader = (title) => (
    <HeaderContainer>
      <div>
        {this.getModelLogo("modal-logo.png")}
        <HeaderTitle>{title}</HeaderTitle>
      </div>
    </HeaderContainer>
  );

  renderFitnessHeader = (title, bgColor, textColor, url, displayLogo=true) => {
    const{ selectedYearInfo } = this.props;
    return <TitleContainer bgColor={"#0D4270"} padding={"0px"} borderRadius={"6px 6px 0 0"} height={"44px"}>
      {displayLogo && this.getModelLogo("running-icon.png")}
      <Title   textTransform={1} textColor={"#fff"} padding={displayLogo ? "3px" : ""}>{title} </Title>
      <CurrentYear>
        <p className={'current-year'}>{(title === "MINUTES ACTIVE ") ? selectedYearInfo :""}</p>
      </CurrentYear>
    </TitleContainer>
  };

  renderFitnessHeaderNew = (title, bgColor, textColor, url, displayLogo=true) => {
    const{ selectedYearInfo } = this.props;
    return <TitleContainer bgColor={"#0D4270"} padding={"0px"} borderRadius={"6px 6px 0 0"} height={"44px"}>
      {displayLogo && this.getModelLogo("running-icon.png")}
      <Title   textTransform={1} textColor={"#fff"} padding={displayLogo ? "3px" : ""}>{title} </Title>
      <CurrentYear>
        <p className={'current-year'}>{(title === "MINUTES ACTIVE ") ? selectedYearInfo :""}</p>
      </CurrentYear>
    </TitleContainer>
  };

  renderFitnessDevicesHeader = (title) => (
    <TitleContainer bgColor={"#0D4270"} padding={"0px 0 0px 0px"} borderRadius={"6px 6px 0 0"}  height={'44px'} >
      <Title textTransform={1} textColor={"#FFFFFF"} className='title-wellness' >{title} </Title>
      <CurrentYear />
    </TitleContainer>
  );

  newRenderFitnessDevicesHeader = (title) => (
    <TitleContainer bgColor={"rgb(243,246,249)"} padding={"0px 0 0 0"} borderRadius={"6px 6px 0 0"}>
      <Title textTransform={1} textColor={"#0D4270"}   paddingTop={'25px'}>{title} </Title>
      <CurrentYear />
    </TitleContainer>
  )

  renderMostActiveUserTitle = (data, title) => (
    <TitleContainer bgColor={"#0D4270"} borderRadius={"6px 6px 0px 0px"} padding={"0px 0 0px 0px"} height={'44px'}>
      <Title textColor={'#fff'}>{title}</Title>
    </TitleContainer>
  );

  showMostActiveUsers = (data, title) => (
    <div>
      { this.renderMostActiveUserTitle(data, title) }
      <CardContainer float={1} textAlign padding = {'0px'}>
        { isEmpty(data) ? <NoData>No most active users found</NoData> : this.showUsersCard(data) }
      </CardContainer>
    </div>
  );

  showLeastActiveUser = (data, title) => (
    <div>
      { this.renderHeader(title) }
      <FitnessCommonContainer float={1} textAlign padding="20px 0px 20px 0px">
        { isEmpty(data) ? 'No least active users found' : this.showUsersCard(data) }
      </FitnessCommonContainer>
    </div>
  );

  showTopFitnessActivity = (topFitnessDetail, title) => {
    if(_.isUndefined(topFitnessDetail) || _.isNull(topFitnessDetail) || isEmpty(topFitnessDetail)) {
      return(
        <div>
          { this.renderFitnessHeader(title, "#1C4667", "#fff", "arrow-white.png", true, "#fff") }
          <FitnessCommonContainer textAlign>
            {
              'No top activities'
            }
          </FitnessCommonContainer>
        </div>
      );
    }

    else {
      const xAxisLabels = map(topFitnessDetail, 'name');
      const data = [{
        name: '',
        data: topFitnessDetail.map((c) => Number(c.percentage)),
        showInLegend: false,
        color: '#0C99C1'
      }];
      return(
        <div>
          { this.renderFitnessHeader(title, "#1C4667", "#fff", "arrow-white.png", true, "#fff") }
          <FitnessCommonContainer textAlign>
            {
              isEmpty(topFitnessDetail) && _.isNull(topFitnessDetail) &&  _.isUndefined(topFitnessDetail)
                ? 'No top activities' :
                <Flexbox>
                  <VerticalBarChart
                    seriesData={data}
                    xAxisLabel={xAxisLabels}
                  />
                </Flexbox>
            }
          </FitnessCommonContainer>
        </div>
      );
    }

  };

  showTopFitnessDevice = (data, title) => (
    <div>
      {this.renderFitnessDevicesHeader(title)}
      <FitnessCommonContainer float={1} padding="0px 20px 0px 15px" solidTop={1}>
        { isEmpty(data) ? <NoData>No top devices found</NoData> : this.showFitnessDetail(data) }
      </FitnessCommonContainer>
    </div>
  );

  showFitnessGoals = (data, title) => {
    if (_.isUndefined(data) || _.isNull(data) || isEmpty(data) || data.length === 0) {
      return (
        <div id="fitness-goals-empty">
          {this.renderFitnessDevicesHeader(title, 1)}
          <FitnessCommonContainer textAlign>
            {'No top Wellness goals'}
          </FitnessCommonContainer>
        </div>
      );
    } else {
      const goalData = [];
      const xAxisLabels = [];
      const goalColors = ["#FD7175", "#69C2FF", "#F6B479", "#9FC989", "#9D87A9"];
      data.map((goal, index) => {
        xAxisLabels.push(goal.name);
        goalData.push({
          "name": goal.name,
          "y": parseInt(goal.percentage, 10),
          "color": goalColors[index]
        });
      });
      let finalData = [{
        name: '',
        data: goalData,
        showInLegend: false,
        color: '#DE9444'
      }];
      return (
        <div id="fitness-goals-container" style={{ height: '100%' }}>
          {this.renderFitnessDevicesHeader(title, 1)}
          <FitnessCommonContainer textAlign height={1}>
            {isEmpty(data) && data.length === 0 ? <NoData>No top Wellness goals</NoData> : <HighChatV2 data={finalData} xAxisLabels={xAxisLabels} container="fitnessGoal" />}
          </FitnessCommonContainer>
        </div>
      );
    }
  }

  getPieChart = (pieChartData) => (
    pieChartData.map((data, index) => (
      <FitnessCommonContainer float={1} key={index}>
        <PieChart pieValue={data.value} bgColor="#93bf3d" title={data.title} containerId={data.id}/>
      </FitnessCommonContainer>
    ))
  );

  renderWeeklyExcerciseDetails = (data) => (
    data.map((item, index) => (
      <FitnessUserCardContainer key={index}>
        <FitnessNewUserCard width="24px"  height={"74px"} borderNone={index === data.length - 1}>
          <FitnessEmployeeGrid color="#333333" gridWidth="65%" paddingLeft={1}>
            <div className="dayInterval">{item.title}</div>
          </FitnessEmployeeGrid>
          <FitnessEmployeeGrid gridWidth="72px" textAlign={1} color="#159fc9" position={'contents'}>
            <BoxData bgColor={item.color}  marginTop= "0px">{item.value}%</BoxData>
          </FitnessEmployeeGrid>
        </FitnessNewUserCard>
      </FitnessUserCardContainer>
    ))
  );

  toggleRadioBtn = (index) => {
    this.setState({
      selectedIndex: index,
      selectedValue: this.state.options[index],
      options: this.state.options
    });
  };

  showWeeklyExercise = (pieChartData, title) => {
    const {displayLogo} = this.state;
    if(_.isUndefined(pieChartData) || _.isNull(pieChartData) || isEmpty(pieChartData)) {
      return(
        <div>
          {this.renderFitnessHeaderNew(title, "#1C4667", "#fff;", "down-arrow.png", displayLogo)}
          <FitnessCommonContainer textAlign>
            {
              'No Weekly Exercise'
            }
          </FitnessCommonContainer>
        </div>
      );
    }
    else {
      const pieData = [
        {
          value: pieChartData.exercise01,
          title: "0 to 1 day",
          id: 'pieChart1',
          color:"rgba(246,180,121,0.15)"
        },
        {
          value: pieChartData.exercise23,
          title: "2 to 3 days",
          id: 'pieChart2',
          color:"rgba(105,194,255,0.15)"
        },
        {
          value: pieChartData.exercise45,
          title: "4 to 5 days",
          id: 'pieChart3',
          color:"rgba(157,135,169,0.15)"
        },
        {
          value: pieChartData.exercise67,
          title: "6 to 7 days",
          id: 'pieChart4',
          color:"rgba(253,113,117,0.15)"
        }
      ];
      return(
        <div>
          {this.renderFitnessHeaderNew(title, "#1C4667", "#fff;", "down-arrow.png", displayLogo)}
          {this.renderWeeklyExcerciseDetails(pieData)}
        </div>
      );
    }
  };

  showDailyActiveMinutes = (data, title) => {
    const {displayLogo} = this.state;
    if(_.isUndefined(data) || _.isNull(data) || isEmpty(data)) {
      return(
        <div>
          {this.renderFitnessHeader(title, "#1C4667", "#fff;", "down-arrow.png", displayLogo)}
          <MinutesActiveDescription>
            <p>
              How many total minutes per day are you active? (eg. chores, walking the dog, playing with the kids)
            </p>
          </MinutesActiveDescription>
          <FitnessCommonContainer textAlign>
            {
              'No Daily Active Minutes'
            }
          </FitnessCommonContainer>
        </div>
      );
    }
    else {
      const pieData = [
        {
          value: data["less_than_15_percentage"],
          title: "Less Than 15 Minutes",
          id: 'pieChart1',
          color:"rgba(246,180,121,0.15)"
        },
        {
          value: data["15_to_30_percentage"],
          title: "15 - 30 Minutes",
          id: 'pieChart2',
          color:"rgba(105,194,255,0.15)"
        },
        {
          value: data["30_to_45_percentage"],
          title: "30 - 45 Minutes",
          id: 'pieChart3',
          color:"rgba(157,135,169,0.15)"
        },
        {
          value: data["45_plus_percentage"],
          title: "45+ Minutes",
          id: 'pieChart4',
          color:"rgba(253,113,117,0.15)"
        }
      ];
      return(
        <div>
          {this.renderFitnessHeader(title, "#1C4667", "#fff;", "down-arrow.png", displayLogo)}
          <MinutesActiveDescription>
            <p>
              How many total minutes per day are you active? (eg. chores, walking the dog, playing with the kids)
            </p>
          </MinutesActiveDescription>
          {this.renderWeeklyExcerciseDetails(pieData)}
        </div>
      );
    }
  };

  showGroupActivityValue = (image,name, steps, colories) => (
    <FitnessCommonContainer float={1} display={1} borderBottom={1} newPadding={1} newHeight={1}>
      <div className="SubSectionNew">
        <FitnessEmployeeGrid gridWidth="100%" groupActivity={1}>
          <GroupButton bgColor='none' textColor=' #0D4270' fontSize='13px' capitalize={1} noSpace={1} newPadding={1} justifycontent={"center"}>
            { image}&nbsp;&nbsp;&nbsp;<span className={"units"}>{ name }</span>
          </GroupButton>
        </FitnessEmployeeGrid>
        <FitnessEmployeeGrid gridWidth="100%" groupActivity={1} color="#0D4270">
          <div className="step">{getUnit(Math.round(steps))} <span className={"units"}>{ name }</span></div>
        </FitnessEmployeeGrid>
        <FitnessEmployeeGrid gridWidth="100%" groupActivity={1} color="#0D4270">
          <div className="values">{getUnit(parseFloat(colories))} <span className={"units"}>{ name }</span></div>
        </FitnessEmployeeGrid>
        <FitnessEmployeeGrid gridWidth="22%" groupActivity={1} color="#0D4270" />
      </div>
    </FitnessCommonContainer>
  );
  
  getBgColor = (value, activeButton) => {
    if(value === activeButton) {
      return '#92A4DA';
    }
    else {
      return false;
    }
  };

  getButtonColor = (value, activeButton) => {
    if(value === activeButton) {
      return '#EFEFEF';
    }
    else {
      return "#BDBDBD";
    }
  }

  getButtonBgColor = (value, activeButton) => {
    if(value === activeButton) {
      return '#fff';
    }
    else {
      return '#0D5783'
    }
  };

  getColor = (value, activeButton) => {
    if(value === activeButton) {
      return '#1E76AB';
    }
    else {
      return '#fff';
    }
  };

  changeActiveIndex = (index, data) => {
    if(this.state.yearButton) {
      this.setState({
        getYear: index
      }, () => {
        this.fetchAPIForActivity();
      })
    }
    this.setState({
      activeIndex: index,
      getDate: data
    }, () => {
      this.fetchAPIForActivity();
    })
  };

  getActivityList = () => {
    const { groupActivitySummaryData, activeIndex } = this.state;
    return groupActivitySummaryData.map((data, index) => (
      <GridGroup grid={groupActivitySummaryData.length} key={index} width= {this.state.activeButton==="Monthly"?"40px":"138px"}>
        {!this.state.yearButton && <GroupButton 
          bgColor={() => this.getBgColor(index, activeIndex)}
          capitalize={1} 
          textColor={() => this.getButtonColor(index, activeIndex)}
          padding="4px 7px"
          fontSize="16px"
          Align={1}
          radius="3px"
          fontFamily="Lato"
          onClick={() => this.changeActiveIndex(index, data)}
          style={{padding:"4px 7px"}}
        >
          {data}
        </GroupButton>}
      </GridGroup>
    ))
  };

  groupActivitySummary = (title,weekData, monthData, yearData) => {
    const { activeButton,activeYear } = this.state;
    const { summaryData,employeeCount} = this.props;
    return (
      <div className="boxShadow">
        <div className="card-top">
          <div className="groupActivity">
            {title}
          </div>
          <div className="emp_count">
            {employeeCount} Employees
          </div>
          <div className="button_cls">
            <CustomDropDown newWidth={'newWidth'}
              inputpadding={"0px"}
              value={this.state.year}
              style={{ color: "white", marginRight:"15px",maxHeight:"39px", display:"flex" }}
              title={activeYear}
              marginRight={"15px"}
            >
              {yearData.map((list, index) => (
                <DropdownItem
                  key={index}
                  newWidth={'newWidth'}
                  value={list}
                  id={3}
                  bgColor={() => this.getButtonBgColor('year', activeButton)}
                  textColor={() => this.getColor('Yearly', activeButton)}
                  onClick={() => this.changeActiveYear(list, yearData, index)}>
                  {list}
                </DropdownItem>
              ))}
            </CustomDropDown>
            <CustomDropDown newWidth={'newWidth'}
              value={this.state.value}
              style={{ color: "white", maxHeight:"39px", display:"flex" }}
              title={activeButton}
              marginLeft={"15px"}
              inputpadding={"0px"}
            >
              <DropdownItem
                newWidth={'newWidth'}
                value="Monthly"
                id={1}
                bgColor={() => this.getButtonBgColor('month', activeButton)}
                textColor={() => this.getColor('Monthly', activeButton)}
                onClick={() => this.changeActiveButton('Monthly', weekData, monthData, yearData)}>
                   Monthly
              </DropdownItem>
              <DropdownItem
                newWidth={'newWidth'}
                value="Quarterly" 
                id={2}  
                bgColor={() => this.getButtonBgColor('week', activeButton)}
                textColor={() => this.getColor('Quarterly', activeButton)}
                onClick={() => this.changeActiveButton('Quarterly', weekData, monthData, yearData)}>
                 Quarterly
              </DropdownItem> 
              <DropdownItem
                newWidth={'newWidth'}
                value="Yearly" 
                id={3}  
                onClick={() => this.changeActiveButton('Yearly', weekData, monthData, yearData)}>
                 Yearly
              </DropdownItem> 
            </CustomDropDown>
          </div>
        </div>
        <FitnessCommonContainer float={1} textAlign={1} padding="0px">
          <ActivityFlex bgColor="#F3F6F9">
            { this.getActivityList() }
          </ActivityFlex>
        </FitnessCommonContainer>
        <FitnessCommonContainer float={1} display={1} padding="8px" color="#3a3a3a">
          <div className="border">
            <FitnessEmployeeGrid gridWidth="100%" newPadding="10px" marginTop="-45px" padding={"25px"} bgColor={"transparent"}>
              Category
            </FitnessEmployeeGrid>
            <FitnessEmployeeGrid gridWidth="100%" groupActivity={1} newPadding={"newPadding"} marginTop="-45px" padding={"25px"} bgColor={"transparent"} color="#3a3a3a">
              User Daily Average
            </FitnessEmployeeGrid>
            <FitnessEmployeeGrid gridWidth="100%" groupActivity={1} newPadding={"newPadding"} marginTop="-45px" padding={"25px"} bgColor={"transparent"} color="#3a3a3a">
              Group Total
            </FitnessEmployeeGrid>
            <FitnessEmployeeGrid gridWidth="22%" groupActivity={1} />
          </div>
        </FitnessCommonContainer>
        <GroupActivityValue>
          { this.showGroupActivityValue(<LazyImage src={ImageUrl + '/images/CompanyDashBoardV2/step.svg'}/>,'Steps', summaryData['average_steps'], summaryData['steps'])}
          { this.showGroupActivityValue(<LazyImage src={ImageUrl + '/images/CompanyDashBoardV2/caloriesNew.svg'}/>,'Calories', summaryData['average_calories'], summaryData['calories'])}
          { this.showGroupActivityValue(<LazyImage src={ImageUrl + '/images/CompanyDashBoardV2/distanceNew.svg'}/>,'Miles', summaryData['average_distance'], summaryData['distance'])}
          <FitnessCommonContainer padding="0 0 14px" float={1} borderTop/>
        </GroupActivityValue>
      </div>
    );
  };

  showFitnessDetail = (data) => (
    data.map((fitness, index) => {
      const Source = fitness.device_name.replace(/ /g, '-');
      return(
        <FitnessNewUserCard key={index} width="24px" height={"76px"} borderNone={index === data.length - 1}>
          <FitnessEmployeeGrid  gridWidth="auto" minWidth={1} borderRadius={1} isBigImage={fitness.device_name === 'garmin'} 
            position={'relative'} bottom={'24px'} right={'0px'}>
            <LazyImage className="device-images" src={`${ImageUrl}/images/Logo/${Source}.png`} alt={fitness.device_name}  style={{width: "50px", height: "auto","margin-right":"20px"}}/>
          </FitnessEmployeeGrid>
          <FitnessEmployeeGrid color="#333333" gridWidth="65%" paddingLeft={1}>
            <div className="deviceName">{fitness.display_name}
              <span>{fitness.user_count} Users</span>
            </div>
          </FitnessEmployeeGrid>
          <FitnessEmployeeGrid gridWidth="72px" gridHeight="38px" textAlign={1} color="#159fc9" borderRadius="6px"  
            bgColor={fitness.color}>
            <div className="fitnessDevice">{fitness.percentage}%</div>
          </FitnessEmployeeGrid>
        </FitnessNewUserCard>
      )
    })
  );
  newFitnessData = (data) => (
    data.map((details, index) => (
      <NewCardContainer key={index}>
        <Row1 padding={1} display={'flex'} style={{float:"unset", paddingTop:"10px"}}>
          <ImgContainer  bgColor={details.color} color={details.text_color}>
            <LazyImage src={`${ImageUrl}/${details.interest_icon}`}/>
          </ImgContainer>
          <div className="textdata">
            <p>{details.name}</p>
          </div>
        </Row1>
        <Row1 padding={1} style={{float:"unset"}}>
          <NewImgContainer color={details.percentage_color }>
            <BarLine color={details.text_color } newWidth={`${details.percentage}%`}>
              &nbsp;&nbsp;
            </BarLine>
          </NewImgContainer>
        </Row1>
        <Row1 paddingTop={'paddingTop'} style={{float:"unset"}}>
          <NewTotalData  style={{float: "left"}} color={details.text_color }>{details.percentage}%</NewTotalData>
        </Row1>
        <Row1 paddingTop={'paddingTop'} style={{float:"unset"}}>
          <div className="totaldata">100%</div>
        </Row1>
      </NewCardContainer>
        
    ))
  );



  newShowTopFitnessDevice = (data, title) => (
    <div>
      {this.newRenderFitnessDevicesHeader(title)}
      <FitnessCommonContainer float={1} padding="0px" solidTop={1} newWidth="100%">
        { isEmpty(data) ? <NoData>No top devices found</NoData> : this.newFitnessData(data) }
      </FitnessCommonContainer>
    </div>
  );


  weeklyExercise = (pieChartData) =>{
    const pieData = [
      {
        value: pieChartData?.exercise01,
        title: "0 to 1 day",
        id: 'pieChart1',
        color:"rgba(246,180,121,0.15)"
      },
      {
        value: pieChartData?.exercise23,
        title: "2 to 3 days",
        id: 'pieChart2',
        color:"rgba(105,194,255,0.15)"
      },
      {
        value: pieChartData?.exercise45,
        title: "4 to 5 days",
        id: 'pieChart3',
        color:"rgba(157,135,169,0.15)"
      },
      {
        value: pieChartData?.exercise67,
        title: "6 to 7 days",
        id: 'pieChart4',
        color:"rgba(253,113,117,0.15)"
      }
    ];
    return(
      <MostActiveUserCard >
        <div className='header'>
          Weekly Exercise
        </div>
        <div className='wrap'>
          {pieChartData?.exercise01||pieChartData?.exercise23||pieChartData?.exercise45||pieChartData?.exercise67?pieData?.length && pieData?.map((data,index)=>
            <div className='card-weekly' key={index} style={{borderBottom:(pieData?.length==index+1) && "none"}}>
              <div className='day'>{data?.title}</div>
              <div className='percentage'>{data?.value}%</div>
            </div>
          ):<div className='no-data'>No Data</div>}
        </div>
      </MostActiveUserCard>
    )
  }

  minuiteActive = (data) =>{
    const pieData = [
      {
        value: data["less_than_15_percentage"],
        title: "Less Than 15 Minutes",
        id: 'pieChart1',
        color:"rgba(246,180,121,0.15)"
      },
      {
        value: data["15_to_30_percentage"],
        title: "15 - 30 Minutes",
        id: 'pieChart2',
        color:"rgba(105,194,255,0.15)"
      },
      {
        value: data["30_to_45_percentage"],
        title: "30 - 45 Minutes",
        id: 'pieChart3',
        color:"rgba(157,135,169,0.15)"
      },
      {
        value: data["45_plus_percentage"],
        title: "45+ Minutes",
        id: 'pieChart4',
        color:"rgba(253,113,117,0.15)"
      }
    ];
    return(
      <MostActiveUserCard>
        <div className='header'>
        Active Minutes
        </div>
        <div className='wrap'>
          { data["less_than_15_percentage"]||data["15_to_30_percentage"]||data["30_to_45_percentage"]||data["45_plus_percentage"]?  pieData?.length && pieData?.map((data,index)=>
            <div className='card-weekly' key={index} style={{borderBottom:(pieData?.length==index+1) && "none"}}>
              <div className='day'>{data?.title}</div>
              <div className='percentage'>{data?.value}%</div>
            </div>
          ):<div className='no-data'>No Data</div>}
        </div>
      </MostActiveUserCard>
    )
  }

  healthData = [
    { name: "Apple Health", value: 250, color: "#DA6C74" },
    { name: "Apple Watch", value: 180, color: "#DA9B6C" },
    { name: "Google Fit", value: 120, color: "#DA9B6C" },
    { name: "Fitbit", value: 100, color: "#DA92C8" },
    { name: "Garmin", value: 30, color: "#92A4DA" },
  ];


  yearly = ()=>(
    <DropdownWrapper>
      <Dropdown  style={{ cursor: "pointer",border:"1px solid #BDBDBD",padding:"14px 16px",borderRadius:"4px" }}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
          <CustomToggleWrapper>
            {this.state.activeYear}
            <span className="dropdown-arrow">{FilterAdminDropIcon()}</span>
          </CustomToggleWrapper>
        </Dropdown.Toggle>
        <CustomMenu
          align="end"
          isTop={"18px"}
          isRight={"-18px"}
          dropdownWidth={"136px"}
          dropdownHeight={"144px"}
        >
          {this.state.yearData?.map((option, index) => (
            <CustomDropdownItem
              key={index}
              eventKey={option}
              active={this.state.activeYear === option}
              onClick={() => this.changeActiveYear(option, this.state.yearData, index)}
            >
              {option}
            </CustomDropdownItem>
          ))}
        </CustomMenu>
      </Dropdown>
    </DropdownWrapper>
  )

  dropdownValue = ()=>(
    <DropdownWrapper>
      <Dropdown  style={{ cursor: "pointer",border:"1px solid #BDBDBD",padding:"14px 16px",borderRadius:"4px" }}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
          <CustomToggleWrapper>
            {this.state.activeButton}
            <span className="dropdown-arrow">{FilterAdminDropIcon()}</span>
          </CustomToggleWrapper>
        </Dropdown.Toggle>
        <CustomMenu
          align="end"
          isTop={"18px"}
          isRight={"-18px"}
          dropdownWidth={"136px"}
          dropdownHeight={"144px"}
        >
          <CustomDropdownItem
            id={1}
            onClick={() => this.changeActiveButton('Monthly', weekData, monthData, this.state.yearData)}>
               Monthly
          </CustomDropdownItem>
          <CustomDropdownItem
            id={2}  
            onClick={() => this.changeActiveButton('Quarterly', weekData, monthData, this.state.yearData)}>
             Quarterly
          </CustomDropdownItem> 
          <CustomDropdownItem
            id={3}  
            onClick={() => this.changeActiveButton('Yearly', weekData, monthData, this.state.yearData)}>
             Yearly
          </CustomDropdownItem> 
        </CustomMenu>
      </Dropdown>
    </DropdownWrapper>
  )

  render() {
    const { summaryData,mostActiveUsers,topDevices,employeeCount, 
      fitnessGoals, topActivities, activeMinutes, fitnessTabLoading, weekExercise} = this.props;

    if(!summaryData ||  !employeeCount || fitnessTabLoading || !this.props.yearList) {
      return <Waiting />
    }
    return(

      <FitnessTabContainer style={{width:"1246px",margin:"auto",float:"none"}}>
        <ContentWrap>
          <CompanyActvity style={{width:"614px", padding:"0px"}}>
            <BarChart heading="Top 5 Wellness Goals" data={fitnessGoals?.slice(0, 5)} id={1} total={"100"} totalText="Recognition Received" barColor={"#B9C8E8"} circleColor={"#B9C8E8"} circleBorderColor={"#B9C8E8"} labelType="text" countKey="percentage" labelKey="name" type="fitness" style={{padding:"16px 16px 0 16px", background:"#FEFEFE99 !important"}}/>
          </CompanyActvity>
          <CompanyActvity style={{width:"611px", paddingBottom:"0"}}>
            <div className='heading-wrap'>
              <div className='first-card'>
                <div className='head'>Company Activity Summary</div>
                <div className='employee'>{employeeCount} Employees</div>
              </div>
              <div className='last-card'>
                {this.dropdownValue()}
                {this.yearly()}
              </div>
            </div>
            <div className='line'/>
            {this.state.activeButton!=="Yearly"?<ActivityFlex bgColor="transparent">
              { this.getActivityList() }
            </ActivityFlex>:<div style={{width:"100%", display:"flex", justifyContent:"center", color:"#BDBDBD", fontFamily:"lato", fontSize:"16px", margin:"4px 0", alignItems:"center"}}>{this.state.activeYear}</div>}
            <CompanyActvityCard>
              <div className='heading-value'>
                <div style={{justifyContent:"flex-start"}}>Category</div>
                <div style={{justifyContent:"center"}}>User Average</div>
                <div style={{justifyContent:"flex-end"}}>Company Total</div>
              </div>
              <div className='activity-value'>
                <div style={{justifyContent:"flex-start"}}>Steps</div>
                <div style={{justifyContent:"center"}}>{getUnit(Math.round(summaryData['average_steps']))} steps</div>
                <div style={{justifyContent:"flex-end"}}>{getUnit(parseFloat(summaryData['steps']))}  steps</div>
              </div>
              <div className='border-line'></div>
              <div className='activity-value'>
                <div style={{justifyContent:"flex-start"}}>Calories</div>
                <div style={{justifyContent:"center"}}> {getUnit(Math.round(summaryData['average_calories']))} calories</div>
                <div style={{justifyContent:"flex-end"}}>{getUnit(parseFloat(summaryData['calories']))}  calories</div>
              </div>
              <div className='border-line'></div>
              <div className='activity-value'>
                <div style={{justifyContent:"flex-start"}}>Distance</div>
                <div style={{justifyContent:"center"}}>{getUnit(Math.round(summaryData['average_distance']))} miles</div>
                <div style={{justifyContent:"flex-end"}}>{getUnit(parseFloat(summaryData['distance']))}  miles</div>
              </div>
            </CompanyActvityCard>
          </CompanyActvity>
        </ContentWrap>
        <ContentWrap style={{marginTop:"20px"}}>
          <div className='activeUserCard'>
            <MostActiveUserCard scroll={mostActiveUsers?.length>4} height={mostActiveUsers?.length>4?"248px":""}>
              <div className='header'>
                Most Active Users
              </div>
              <div className='wrap' >
                {mostActiveUsers?.length===0?<div className='no-data'>No data</div>:  mostActiveUsers?.map((data,index)=>
                  <div className='card-active' key={index} style={{borderBottom:mostActiveUsers?.length===(index+1)&&"none"}}>
                    <div className='image'>
                      <img  src={`${ImageUrl}/${data.profile_image}`} alt="no-data" />
                    </div>
                    <div className='wrap-card' style={{width:'100%'}}>
                      <div className='name'>{data.name}</div>
                      <div className='department'>{cleanUpCommas(data.department)} {data?.department&&data.location? "|":""} {cleanUpCommas(data.location)}</div>
                    </div>
                    <div className='last-card'></div>
                  </div>
                )}
              </div>
            </MostActiveUserCard>
          </div>
          <div className='activeUserCard'>
            {this.weeklyExercise(weekExercise)}
          </div>
          <div className='activeUserCard'>
            {this.minuiteActive(activeMinutes)}
          </div>
        </ContentWrap>
        <ContentWrap>
          <FitnessDeviceCard >
            <div className="heading">Top 5 Fitness Devices</div>
            <div className="details">
              {topDevices?.length>0?<div className="title">{Number(topDevices?.[0]?.user_count || 0) + Number(topDevices[1]?.user_count || 0) + Number(topDevices[2]?.user_count || 0) + Number(topDevices[3]?.user_count || 0) + Number(topDevices[4]?.user_count || 0)}
                <div className="subtitle">Devices Connected</div>
              </div>:null}
              <div className="wrap-card" style={{paddingBottom: topDevices?.length===0?"0px": "45px"}}>
                {topDevices?.length===0?<div className='no-data'>No Data</div>:
                  <>
                    <div className="device">
                      {topDevices?.length && topDevices?.map((data, index)=>
                        <div className="device-name" key={index}>
                          <div className="circle" style={{background:this.healthData[index]?.color}}/>
                          <div className="count">{data?.display_name}:&nbsp;{data?.user_count}</div>
                        </div>)}
                    </div>
                    <div className="device-images">
                      {topDevices?.length>2 && topDevices[3]?.device_name&&<div className="fitbit" style={{padding:topDevices[3]?.device_name==="healthapp"||topDevices[3]?.device_name==="strava"?"0":"24px"}}>
                        <img src={`${ImageUrl}/images/Logo/${topDevices[3]?.device_name}.png`} />
                      </div>}
                      {topDevices?.[0]?.device_name&&<div className="health" style={{padding:topDevices?.[0]?.device_name==="healthapp"||topDevices?.[0]?.device_name==="strava"?"0":"24px"}}>
                        <img src={`${ImageUrl}/images/Logo/${topDevices?.[0]?.device_name}.png`} />
                      </div>}
                      {topDevices?.length>3 && topDevices[4]?.device_name&&<div className="garmin" style={{padding:topDevices[4]?.device_name==="healthapp"||topDevices[4]?.device_name==="strava"?"0":"24px"}}>
                        <img src={`${ImageUrl}/images/Logo/${topDevices[4]?.device_name}.png`} />
                      </div>}
                      {topDevices?.length>2 && topDevices[2]?.device_name&&<div className="googlefit" style={{padding:topDevices[2]?.device_name==="healthapp"||topDevices[2]?.device_name==="strava"?"0":"24px"}}>
                        <img src={`${ImageUrl}/images/Logo/${topDevices[2]?.device_name}.png`} />
                      </div>}
                      {topDevices?.length>1 && topDevices[1]?.device_name&&<div className="applewatch" style={{padding:topDevices[1]?.device_name==="healthapp"||topDevices[1]?.device_name==="strava"?"0":"24px"}}>
                        <img src={`${ImageUrl}/images/Logo/${topDevices[1]?.device_name}.png`} />
                      </div>}
                    </div>
                  </>}
              </div>
            </div>  
          </FitnessDeviceCard>
        </ContentWrap>
        <FitnessActivityWrap>
          <div className='heading'>Top 15 Fitness Activities</div>
          <div className='line'></div>
          <div className='fitness-wrap'>
            {topActivities?.length===0?<div className='no-data'>No Data</div>: topActivities?.map((details,index)=>(
              <div className='fitness' key={index}>
                <FitnessActivityCard>
                  <div className='icon-wrap'>
                    <div className='image'>
                      <img src={`${ImageUrl}/${details.interest_icon}`}/>
                    </div>
                    <div className='activity'>{details.name}</div>
                  </div>
                  <div className='percentage'>
                    <ProgressBar
                      height={"16px"}
                      backgroundActive={details?.text_color}
                      background={"#EFEFEF"}
                      width={details?.percentage}
                      paddingRight="0px"
                    >
                      <div className="progress"></div>
                      <div className="percentageValue">
                        {details?.percentage > 0
                          ? `${details?.percentage}%`
                          : null}
                      </div>
                    </ProgressBar>
                  </div>
                </FitnessActivityCard>
              </div>))}
          </div>
        </FitnessActivityWrap>
      </FitnessTabContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  summaryData: state.companyDashboard.groupActivitySummary,
  employeeCount: state.companyDashboard.employeeCount
});
const mapDispatchToProps = (dispatch) => ({
  
  fetchGroupActivitySummary: ( companyId, startDate, endDate) => dispatch(FetchGroupActivitySummary( companyId, startDate, endDate)),
});

FitnessTab.propTypes = {
  mostActiveUsers: PropTypes.array,
  leastActiveUsers: PropTypes.array,
  topDevices: PropTypes.array,
  fitnessGoals: PropTypes.array,
  topActivities: PropTypes.array,
  weekExercise: PropTypes.object,
  fetchGroupActivitySummary: PropTypes.func,
  companyId: PropTypes.number,
  summaryData: PropTypes.object,
  activeMinutes : PropTypes.object,
  selectedYearInfo: PropTypes.number,
  fitnessTabLoading: PropTypes.bool,
  yearList: PropTypes.array,
  employeeCount: PropTypes.number 
};

export default connect(mapStateToProps, mapDispatchToProps)(FitnessTab);
